import { z } from 'zod';
import { taskTypeZodWithCatch } from 'packages/lib/api/annotations/contract/enums';

export const instructionZod = z.object({
  token: z.string(),
  name: z.nullable(z.string()),
  tag: z.nullable(z.string()),
  description: z.nullable(z.string()),
  instructionText: z.nullable(z.string()),
  property: z.nullable(z.string()),
  attachmentToken: z.nullable(z.string()),
  type: taskTypeZodWithCatch.nullable(), // Per Edvin: type is populated for all 2023+ instructions, and null prior.
  version: z.nullable(z.string()), // Per Edvin: for all 2021+ instructions, this starts with a 4-digit year, i.e. "2023-1". Pre-2021, it is a different format, i.e. "1.2"
  link: z.nullable(z.string()),
});

export const instructionsRespZod = z.array(instructionZod);

export type InstructionResp = z.infer<typeof instructionsRespZod>;
export type Instruction = z.infer<typeof instructionZod>;
